import React from 'react';
import PropTypes from 'prop-types';
import { tokenIsExpired } from 'utils/Request';
import { getItem } from 'utils/LocalStorage';
import classes from './ImportProduct.module.scss';

const ImportProductStep2 = (props) => {
  const {
    createProducts,
    cancelProcess,
    renderButton,
    productsToCreate,
  } = props;

  const checkToken = () => {
    const isExpired = tokenIsExpired(getItem('API_TOKEN'));
    return isExpired ? (
      <div>
        {
          renderButton(
            'ButtonB',
            'Your session has expired, click here to reload the page.',
            () => document.location.reload(),
          )
        }
      </div>
    ) : (
      <div>
        {renderButton('ButtonA', 'Yes, continue', createProducts)}
        {renderButton('ButtonB', 'No, cancel and upload a new file', cancelProcess)}
      </div>
    );
  };

  return productsToCreate > 0 ? (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <h2 className={classes.title}>
          Ready to upload <span className={classes.productTotal}>{productsToCreate}</span> products.
        </h2>
        {checkToken()}
      </div>
    </div>
  ) : (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <h2 className={classes.title}>
          No products in your file. Please check the file and upload it again
        </h2>
        {renderButton('ButtonB', 'Upload a new file', cancelProcess)}
      </div>
    </div>
  );
};

ImportProductStep2.propTypes = {
  createProducts: PropTypes.func,
  cancelProcess: PropTypes.func,
  renderButton: PropTypes.func,
  productsToCreate: PropTypes.number,
};

export default ImportProductStep2;
